import { render, staticRenderFns } from "./DrawListWinners.vue?vue&type=template&id=52bb02b4&scoped=true"
import script from "./DrawListWinners.vue?vue&type=script&lang=js"
export * from "./DrawListWinners.vue?vue&type=script&lang=js"
import style0 from "./DrawListWinners.vue?vue&type=style&index=0&id=52bb02b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb02b4",
  null
  
)

export default component.exports